import { withInstall } from '@jdesign-vue/utils'
import CheckTag from './src/check-tag.vue'

export const JdCheckTag = withInstall(CheckTag)
export default JdCheckTag

export * from './src/check-tag'
